import { useContext } from "react";
import { ThemeContext } from "../Contexts";
export function useTheme() {
    const { theme, vendorTheme } = useContext(ThemeContext);
    return {
        theme,
        vendorTheme,
    };
}
